import * as React from "react";
import AppBar from "@mui/material/AppBar";
import { useEffect, useState } from "react";
import "./AppBar.css";
import useDebounce from "../../Hooks/useDebounce";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { styled, alpha } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { CustomButton } from "../CustomButton/CustomButton";
import { Theme } from "../../config/aws-exports";
import logo from "../../assets/USP logo R.png";
import { useNavigate } from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import { API } from "aws-amplify";
import config from "../../config/aws-exports";
import SearchIcon from "@mui/icons-material/Search";
//import { useDispatch, useSelector } from "react-redux";
//import { authData } from "../../redux/auth/authSlice";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "25ch",
    },
  },
}));

export default function AppBarLandingPage({ handleLoginClick }) {
  const [searchVal, setSearchVal] = useState("");
  //const dispatch = useDispatch();
  const deboundedValue = useDebounce(searchVal, 1000);
  //const userDetails = useSelector(authData);
  const navigate = useNavigate();

  useEffect(() => {
    async function getMyCourse() {
      if (!deboundedValue) return;

      const bodyParam = {
        body: {
          oid: config.aws_org_id,
          searchTerm: deboundedValue,
          schema: config.schema,
          //tenant: userDetails?.tenant ?? "public",
        },

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      console.log("body", bodyParam);
      try {
        await API.post(
          config.aws_cloud_logic_custom_name,
          "/searchCourse", // must NOT have space
          bodyParam,
        );
      } catch (err) {
        console.error(err);
      }
    }

    getMyCourse();
  }, [deboundedValue]);

  const handleSearch = async () => {
    navigate(`/resultspre?search_query=${encodeURIComponent(searchVal)}`);
    setSearchVal("");
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor: Theme.color.secondary }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2, display: { xs: "none", sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <img
            src={logo}
            alt="logo"
            height="60"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/");
            }}
          />

          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <div style={{ position: "relative", width: "300px" }}>
              <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>

                <StyledInputBase
                  placeholder="Search…"
                  inputProps={{ "aria-label": "search" }}
                  value={searchVal}
                  onChange={(event) => setSearchVal(event.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                />
              </Search>
            </div>
          </Box>

          <CustomButton onClick={handleLoginClick("login")} secondary>
            Login
          </CustomButton>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
